// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Strengthify - show the weakness of a password (uses zxcvbn for this)
 * https://github.com/MorrisJobke/strengthify
 * Version: 0.5.9
 * License: The MIT License (MIT)
 * Copyright (c) 2013-2020 Morris Jobke <morris.jobke@gmail.com>
 */

.strengthify-wrapper {
    position: relative;
}

.strengthify-wrapper > * {
	-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
	filter: alpha(opacity=0);
	opacity: 0;
	-webkit-transition:all .5s ease-in-out;
	-moz-transition:all .5s ease-in-out;
	transition:all .5s ease-in-out;
}

.strengthify-bg, .strengthify-container, .strengthify-separator {
	height: 3px;
}

.strengthify-bg, .strengthify-container {
	display: block;
	position: absolute;
	width: 100%;
}

.strengthify-bg {
	background-color: #BBB;
}

.strengthify-separator {
	display: inline-block;
	position: absolute;
	background-color: #FFF;
	width: 1px;
	z-index: 10;
}

.password-bad {
	background-color: #C33;
}
.password-medium {
	background-color: #F80;
}
.password-good {
	background-color: #3C3;
}

div[data-strengthifyMessage] {
    padding: 3px 8px;
}

.strengthify-tiles{
	float: right;
}
`, "",{"version":3,"sources":["webpack://./node_modules/strengthify/strengthify.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;IACI,kBAAkB;AACtB;;AAEA;CACC,+DAA+D;CAC/D,wBAAwB;CACxB,UAAU;CACV,sCAAsC;CACtC,mCAAmC;CACnC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;CACtB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;CACC,YAAY;AACb","sourcesContent":["/**\n * Strengthify - show the weakness of a password (uses zxcvbn for this)\n * https://github.com/MorrisJobke/strengthify\n * Version: 0.5.9\n * License: The MIT License (MIT)\n * Copyright (c) 2013-2020 Morris Jobke <morris.jobke@gmail.com>\n */\n\n.strengthify-wrapper {\n    position: relative;\n}\n\n.strengthify-wrapper > * {\n\t-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n\tfilter: alpha(opacity=0);\n\topacity: 0;\n\t-webkit-transition:all .5s ease-in-out;\n\t-moz-transition:all .5s ease-in-out;\n\ttransition:all .5s ease-in-out;\n}\n\n.strengthify-bg, .strengthify-container, .strengthify-separator {\n\theight: 3px;\n}\n\n.strengthify-bg, .strengthify-container {\n\tdisplay: block;\n\tposition: absolute;\n\twidth: 100%;\n}\n\n.strengthify-bg {\n\tbackground-color: #BBB;\n}\n\n.strengthify-separator {\n\tdisplay: inline-block;\n\tposition: absolute;\n\tbackground-color: #FFF;\n\twidth: 1px;\n\tz-index: 10;\n}\n\n.password-bad {\n\tbackground-color: #C33;\n}\n.password-medium {\n\tbackground-color: #F80;\n}\n.password-good {\n\tbackground-color: #3C3;\n}\n\ndiv[data-strengthifyMessage] {\n    padding: 3px 8px;\n}\n\n.strengthify-tiles{\n\tfloat: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
